import React from 'react';
import { motion } from 'framer-motion';
import { Sparkles, ArrowRight } from 'lucide-react';

const FE_WEB_URL = 'https://app.tradiora.id';

function HeroSection() {
  return (
    <section
      className="features-hero"
      style={{
        background: 'linear-gradient(135deg, #0b1120 0%, #0f1a3a 40%, #1a0f2e 100%)',
      }}
    >
      <div className="features-hero__glow features-hero__glow--teal" />
      <div className="features-hero__glow features-hero__glow--purple" />

      <div className="container" style={{ position: 'relative', zIndex: 1 }}>
        <div className="row">
          <div className="col-md-12" style={{ textAlign: 'center' }}>
            <motion.div
              initial={{ opacity: 0, y: 20 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.6 }}
            >
              <div className="features-hero__badge">
                <Sparkles size={14} />
                <span>All-in-One Trading Platform</span>
              </div>
            </motion.div>

            <motion.h1
              initial={{ opacity: 0, y: 20 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.6, delay: 0.15 }}
              style={{
                fontSize: 52,
                fontWeight: 700,
                color: '#fff',
                lineHeight: 1.15,
                marginBottom: 20,
                letterSpacing: '-1.5px',
              }}
            >
              Semua yang Anda Butuhkan untuk{' '}
              <span style={{ background: 'linear-gradient(135deg, #0C8F86, #8b5cf6)', WebkitBackgroundClip: 'text', WebkitTextFillColor: 'transparent' }}>
                Menjadi Trader
              </span>{' '}
              yang Konsisten
            </motion.h1>

            <motion.p
              initial={{ opacity: 0, y: 20 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.6, delay: 0.3 }}
              style={{
                fontSize: 18,
                color: 'rgba(255,255,255,0.5)',
                maxWidth: 600,
                margin: '0 auto 36px',
                lineHeight: 1.7,
              }}
            >
              Belajar investasi, analisis AI, mentoring profesional, komunitas eksklusif, hingga paper trading dalam satu platform.
            </motion.p>

            <motion.div
              initial={{ opacity: 0, y: 20 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.6, delay: 0.45 }}
              style={{ display: 'flex', gap: 16, justifyContent: 'center', flexWrap: 'wrap' }}
            >
              <a href={FE_WEB_URL} className="btn-action" style={{ display: 'inline-flex', alignItems: 'center', gap: 8, padding: '16px 36px', borderRadius: 14, fontSize: 16, fontWeight: 700, color: '#fff', background: 'linear-gradient(135deg, #0C8F86, #087a72)', border: 'none', cursor: 'pointer', textDecoration: 'none', transition: 'all 0.3s ease' }}
                onMouseEnter={e => { e.currentTarget.style.transform = 'translateY(-2px)'; e.currentTarget.style.boxShadow = '0 12px 40px rgba(12,143,134,0.35)'; }}
                onMouseLeave={e => { e.currentTarget.style.transform = 'translateY(0)'; e.currentTarget.style.boxShadow = 'none'; }}
              >
                Mulai Gratis <ArrowRight size={18} />
              </a>
              <a href={`${FE_WEB_URL}/login`} style={{ display: 'inline-flex', alignItems: 'center', gap: 8, padding: '16px 36px', borderRadius: 14, fontSize: 16, fontWeight: 600, color: 'rgba(255,255,255,0.7)', background: 'rgba(255,255,255,0.05)', border: '1px solid rgba(255,255,255,0.1)', cursor: 'pointer', textDecoration: 'none', transition: 'all 0.3s ease' }}
                onMouseEnter={e => { e.currentTarget.style.transform = 'translateY(-2px)'; e.currentTarget.style.borderColor = 'rgba(255,255,255,0.2)'; }}
                onMouseLeave={e => { e.currentTarget.style.transform = 'translateY(0)'; e.currentTarget.style.borderColor = 'rgba(255,255,255,0.1)'; }}
              >
                Masuk
              </a>
            </motion.div>
          </div>
        </div>
      </div>
    </section>
  );
}

export default HeroSection;
